import React from 'react';
import PropTypes from 'prop-types';
import { Box, Grid2 as Grid } from '@mui/material';

function EmptyState({
  icon,
  content,
  action = null,
  secondaryAction,
  error = false,
  ratio = 'auto',
  ...props
}: any) {
  const [width, height] = ratio.split(':');
  const calculatedRatio = parseInt(width, 10) / parseInt(height, 10);

  return (
    <Box
      sx={(theme: any) => ({
        border: `1px dashed ${error ? theme.palette.error.main : theme.palette.divider}`,
        borderRadius: theme.shape.borderRadius / 2,
        padding: theme.spacing(6),
        maxWidth: '100%',
        margin: 0,
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        aspectRatio: calculatedRatio,
        ...(props.onClick || props.onDrop || props.onDragOver
          ? {
              '&:hover': {
                cursor: 'pointer',
                borderColor: theme.palette.primary.main,
                color: theme.palette.primary.main,
                backgroundColor: theme.palette.action.hover,
              },
            }
          : {}),
      })}
      {...props}
    >
      <Grid
        container
        direction="row"
        spacing={2}
        sx={{
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {icon && (
          <Grid
            size={12}
            sx={{
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            {icon}
          </Grid>
        )}

        {content && <Grid size={12}>{content}</Grid>}

        {(action || secondaryAction) && (
          <Grid
            container
            direction="row"
            spacing={2}
            size={12}
            sx={{
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Grid>{action}</Grid>
            <Grid>{secondaryAction && secondaryAction}</Grid>
          </Grid>
        )}
      </Grid>
    </Box>
  );
}

EmptyState.propTypes = {
  icon: PropTypes.element,
  content: PropTypes.element,
  action: PropTypes.element,
  secondaryAction: PropTypes.element,
  error: PropTypes.bool,
  component: PropTypes.elementType,
};

export default EmptyState;
